// extracted by mini-css-extract-plugin
export var active = "_27-a";
export var activeIndicator = "_27-8";
export var animate = "_27-9";
export var disabled = "_27-b";
export var fullWidth = "_27-2";
export var lg = "_27-7";
export var md = "_27-6";
export var redoButtonTabGroup = "_27-0";
export var sm = "_27-5";
export var tabButton = "_27-3";
export var tabButtonsContainer = "_27-1";
export var xs = "_27-4";